<script setup lang="ts">
import { Icon } from '@iconify/vue'
import { Plus } from '@element-plus/icons-vue'
import { computed, ref } from 'vue'

interface IFilterListItem {
  key: string
  value: string
  type: string
  options: Array<{ key: string; value: string }>
  placeholder: string
  visible?: boolean
  modelValue: any
  onChange: (value: any) => void
  iconClass: string
  style?: string
}

const props = defineProps<{ filtersList: Array<IFilterListItem> }>()

const showAddFilterButton = computed(() => {
  return !props.filtersList ? false : dropdownTypedFilters.value.length < props.filtersList?.length
})

const filtersOptions = ref<IFilterListItem[]>()

if (props.filtersList) {
  filtersOptions.value = [...props.filtersList]
}

const dropdownTypedFilters = ref<IFilterListItem[]>([])

const generateIconClass = (iconClass: string) => {
  return `material-symbols:${iconClass}`
}

const handleFilterChange = (filterKey: string) => {
  const filter = filtersOptions.value?.find((filter) => filter.key === filterKey)

  if (filter) {
    dropdownTypedFilters.value?.push(filter)
    filtersOptions.value = filtersOptions.value?.filter((item) => item.key !== filterKey)
  }
}

const handleFilterDelete = (filter: IFilterListItem) => {
  filter.modelValue = undefined
  filter.onChange(undefined)

  dropdownTypedFilters.value = dropdownTypedFilters.value.filter((item) => item.key !== filter.key)
  filtersOptions.value?.push(filter)
}
</script>

<template>
  <div class="flex flex-row flex-start align-center">
    <div v-for="filter in dropdownTypedFilters" :key="filter.key" class="pr-sm">
      <el-badge badge-class="bg-fill-primary" :offset="[-10, 0]">
        <template #content>
          <Icon
            icon="material-symbols:delete-outline"
            class="cursor-pointer color-fill-invert"
            height="16"
            :inline="true"
            @click="handleFilterDelete(filter)"
          />
        </template>
        <el-select
          v-model="filter.modelValue"
          :placeholder="filter.placeholder"
          class="table-filters__input"
          clearable
          :style="filter.style ?? 'width: 200px'"
          @change="filter.onChange"
        >
          <el-option v-for="option in filter.options" :key="option.key" :label="option.value" :value="option.key" />
        </el-select>
      </el-badge>
    </div>
    <el-dropdown v-if="showAddFilterButton" trigger="click" @command="handleFilterChange">
      <el-button>
        <el-icon class="el-icon--left">
          <Plus />
        </el-icon>
        Filter
      </el-button>
      <template #dropdown>
        <el-dropdown-menu>
          <el-dropdown-item v-for="item in filtersOptions" :key="item.key" :command="item.key">
            <Icon v-if="item.iconClass" :icon="generateIconClass(item.iconClass)" :width="18" class="mr-1.25" />
            {{ item.value }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </template>
    </el-dropdown>
  </div>
</template>
